<h2 mat-dialog-title>{{ inputData.title }}</h2>
<mat-dialog-content [formGroup]="avenantForm">
    <mat-form-field class="example-full-width">
      <mat-label>Avenants</mat-label>
      <mat-select formControlName="name" #select>
        <mat-option disabled>Choisir un avenant ...</mat-option>
        @for (item of avenantListe ; track $index) {
          <mat-option [value]="item.key" [disabled]="item.disable">{{ item.title |  uppercase }}</mat-option>
        }
      </mat-select>
      @if (avenantForm.get('name')?.hasError('required') && avenantForm.get('name')?.touched) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    @switch (select.value) {
      @case ('remise') {
        <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <mat-form-field appearance="outline">
        <mat-label>Nouvelle Date d'effet</mat-label>
        <input
          matInput
          formControlName="date_effet"
          [matDatepicker]="picker"
          (dateChange)="setEndDateForRemise()"
          >
        <mat-hint></mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" >
        <mat-label>Nouvelle Date de fin</mat-label>
        <input
          matInput
          [readonly]="true"
          formControlName="date_fin"
          [matDatepicker]="pickerEnd"
          >
        <mat-hint></mat-hint>
        <mat-datepicker-toggle [disabled]="true" matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      }
      @case ('report_date') {
        <mat-form-field>
          <mat-label>Date (en jours)</mat-label>
          <input matInput type="number" formControlName="report_date" placeholder="date en jours" />
        </mat-form-field>
        <a mat-list-item>Date de fin : {{ newDateReport() | date }}</a>
        <hr>
        <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
      @case ('duplicata') {
        <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
      @case ('immat') {
        <mat-form-field>
          <mat-label>Immatriculation</mat-label>
          <input matInput type="text" formControlName="immat"
            #inputI
            (blur)="checkValue('immatriculation', inputI.value, 'immat')"
            placeholder="Immatriculation" />
            @if (avenantForm.get('immat')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
            @if (avenantForm.get('immat')?.hasError('exist')) {<mat-error>Cette immatriculation est déjà utilisée</mat-error>}
        </mat-form-field>
        <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
      @case ('vehicule') {
        <mat-form-field appearance="outline">
          <mat-label>Vehicle</mat-label>
          <input matInput readonly formControlName="vehicule_name" type="text">
          <button matButton matSuffix
          (click)="vehiculesNonVehicules()"
          [color]="(this.avenantForm.get('vehicule_name')?.value=='')?'warn':'primary'"
          matTooltip="selectionner">
            <mat-icon >ink_selection</mat-icon>
            @if (loadVehiculeNa()) {
              <mat-spinner diameter="15"></mat-spinner>
            }
          </button>
        </mat-form-field>
        <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
      @case ('changeName') {
        <mat-form-field appearance="outline">
          <mat-label>Nom</mat-label>
          <input
            matInput
            type="text"
            formControlName="firstname"
            placeholder="Entrez le nom de l'assure">
          @if (assuranceForm.get('firstname')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Prenom</mat-label>
          <input
            matInput
            type="text"
            formControlName="lastname"
            placeholder="Entrez le prenom de l'assure">
          @if (assuranceForm.get('lastname')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Genre</mat-label>
          <mat-select formControlName="gender">
            <mat-option value="" disabled="">Choisir un genre</mat-option>
            <mat-option value="masculin">Masculin</mat-option>
            <mat-option value="feminin">Feminin</mat-option>
          </mat-select>
          @if (assuranceForm.get('gender')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>
                <div class="row" [formGroup]="assuranceForm">
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Carte rose</mat-label>
              <input matInput readonly formControlName="carte_rose" type="text">
              <button matButton matSuffix
              (click)="selectCarteRose()"
              [color]="(this.assuranceForm.get('carte_rose')?.value=='')?'warn':'primary'"
              matTooltip="selectionner">
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="col col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>N* Attestation</mat-label>
              <input matInput readonly formControlName="attestation" type="text">
              <button matButton matSuffix
              (click)="selectAttestation()"
              [color]="(this.assuranceForm.get('attestation')?.value=='')?'warn':'primary'"
              matTooltip="selectionner" >
                <mat-icon >ink_selection</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      }
    }

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close cdkFocusInitial class="bg-mat-red">Fermer</button>
  @switch (select.value) {
    @case ('report_date') {
      <button mat-button class="bg-mat-green"
        [disabled]="avenantForm.invalid ||
        assuranceForm.invalid ||
        avenantForm.get('report_date')?.value==0"
      (click)="onAdd()">Enregistrer</button>
    }
    @case ('duplicata') {
       <button mat-button class="bg-mat-green" [disabled]="avenantForm.invalid || assuranceForm.invalid" (click)="onAdd()">Enregistrer</button>
    }
    @case ('remise') {
      <button
      mat-button class="bg-mat-green"
      [disabled]="assuranceForm.invalid ||
      avenantForm.get('date_effet')?.value=='' ||
      avenantForm.get('date_fin')?.value=='' ||
      avenantForm.get('periode')?.value==''"
      (click)="onAdd()">Enregistrer</button>
    }
    @case ('immat') {
      <button
      mat-button class="bg-mat-green"
      [disabled]="avenantForm.get('immat')?.value=='' ||
      assuranceForm.invalid"
      (click)="onAdd()">Enregistrer</button>
    }
    @case ('vehicule') {
      <button
      mat-button class="bg-mat-green"
      [disabled]="avenantForm.get('vehicule_id')?.value=='' ||
      assuranceForm.invalid"
      (click)="onAdd()">Enregistrer</button>
    }
    @case ('changeName') {
      <button
      mat-button class="bg-mat-green"
      [disabled]="avenantForm.get('firstname')?.value=='' ||
      assuranceForm.invalid"
      (click)="onAdd()">Enregistrer</button>
    }
    @default {
      <button mat-button class="bg-mat-green" [disabled]="avenantForm.invalid" (click)="onAdd()">Enregistrer</button>
    }
  }
</mat-dialog-actions>
